import * as types from "../../actions/actionTypes";

const initialState = {
  channelSettings: [],
  channelSettingsSelected: {}
};

const channelSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_CHANNEL_SETTINGS:
      return { ...state, channelSettings: [...state.channelSettings, action.channelSettings] };
      case types.CLEAN_CHANNEL_SETTINGS:
      return { ...state, channelSettings: [], channelSettingsSelected: {} };
    default:
      return state;
  }
};

export default channelSettingsReducer;



// WEBPACK FOOTER //
// ./src/reducers/pomui/channelSettingsReducer.js